'use strict';

const LoaderSvc = [
  '$activityIndicator',
  '$rootScope',
  '$timeout',
  'ToastrSvc',
  function(
    $activityIndicator,
    $rootScope,
    $timeout,
    ToastrSvc
  ) {
    var _glob = {
      //index each timeout with its own true/false value
      //  push and update/check last index, psuedo stack
      hasTimeOut: [],
    };
    function _parseLoaderType(type) {
      var className = '';
      switch (type) {
      case 'circle':
        className = 'loader-circle';
        break;
      case 'boxes':
        className = 'loader-boxes';
        break;
      default:
        className = 'loader-circle';
      }
      return className;
    }
    return {
      start(msg, type) {
        $rootScope.loadingText = msg ? msg.toString() : null;
        $rootScope.AIType = _parseLoaderType(type);
        $activityIndicator.startAnimating();
      },
      startTimeOut(time, msg, type) {
        $rootScope.loadingText = msg ? msg.toString() : null;
        $rootScope.AIType = _parseLoaderType(type);
        $activityIndicator.startAnimating();

        //defualt 15 seconds if no time passed in
        time = time ? time : 15000;
        var timeOutMs = time.toString();

        var index = _glob.hasTimeOut.length;
        _glob.hasTimeOut[index] = true;
        $timeout(function() {
          if($activityIndicator.isAnimating() && _glob.hasTimeOut[index]) {
            $activityIndicator.stopAnimating();
            ToastrSvc.error('Error: Server Timeout (>' + timeOutMs + 'ms).');
          }
        }, time);
      },
      stop() {
        $activityIndicator.stopAnimating();

        var len = _glob.hasTimeOut.length;
        if(len > 0 && _glob.hasTimeOut[len - 1]) {
          _glob.hasTimeOut[len - 1] = false;
        }
      },
      stopSuccess(msg) {
        $activityIndicator.stopAnimating();

        msg = msg ? msg.toString() : 'Success';
        ToastrSvc.success(msg);

        var len = _glob.hasTimeOut.length;
        if(len > 0 && _glob.hasTimeOut[len - 1]) {
          _glob.hasTimeOut[len - 1] = false;
        }
      },
      stopError(msg) {
        $activityIndicator.stopAnimating();

        if(msg) {
          msg = msg.data ? msg.data : msg;
          msg = msg.toString();
        }
        if(typeof msg !== 'string') {
          msg = 'Unspecified Error - Contact System Administrator';
        }
        ToastrSvc.error(msg);

        var len = _glob.hasTimeOut.length;
        if(len > 0 && _glob.hasTimeOut[len - 1]) {
          _glob.hasTimeOut[len - 1] = false;
        }
      },
      stopWarning(msg, detail) {
        $activityIndicator.stopAnimating();

        if(msg) {
          msg = msg.data ? msg.data : msg;
          msg = msg.toString();
        }
        if(typeof msg !== 'string') {
          msg = 'Warning - Please Check Results';
        }

        // Show warning message using ToastrSvc
        // If ToastrSvc has a warning method, use it, otherwise use info
        if(ToastrSvc.warning) {
          ToastrSvc.warning(msg, detail);
        } else {
          ToastrSvc.info(msg + (detail ? ' ' + detail : ''));
        }

        var len = _glob.hasTimeOut.length;
        if(len > 0 && _glob.hasTimeOut[len - 1]) {
          _glob.hasTimeOut[len - 1] = false;
        }
      }
    };
  }
];
export default LoaderSvc;
//
// // old loader service
// angular.module('georgeApp')
//   .factory('LoaderSvc',
//     function($activityIndicator, $rootScope, $timeout, ToastrSvc) {
//       var _glob = {
//         // index each timeout with its own true/false value
//         //  push and update/check last index, psuedo stack
//         hasTimeOut: [],
//       };
//       function _parseLoaderType(type) {
//         var className = '';
//         switch (type) {
//         case 'circle':
//           className = 'loader-circle';
//           break;
//         case 'boxes':
//           className = 'loader-boxes';
//           break;
//         default:
//           className = 'loader-circle';
//         }
//         return className;
//       }
//       return {
//         start(msg, type) {
//           $rootScope.loadingText = msg ? msg.toString(): null;
//           $rootScope.AIType = _parseLoaderType(type);
//           $activityIndicator.startAnimating();
//         },
//         startTimeOut(time, msg, type) {
//           $rootScope.loadingText = msg ? msg.toString(): null;
//           $rootScope.AIType = _parseLoaderType(type);
//           $activityIndicator.startAnimating();
//
//           //defualt 15 seconds if no time passed in
//           time = time ? time: 15000;
//           var timeOutMs = time.toString();
//
//           var index = _glob.hasTimeOut.length;
//           _glob.hasTimeOut[index] = true;
//           $timeout(function() {
//            if($activityIndicator.isAnimating() && _glob.hasTimeOut[index]) {
//               $activityIndicator.stopAnimating();
//             ToastrSvc.error('Error: Server Timeout (>' + timeOutMs + 'ms).');
//             }
//           }, time);
//         },
//         stop() {
//           $activityIndicator.stopAnimating();
//
//           var len = _glob.hasTimeOut.length;
//           if(len > 0 && _glob.hasTimeOut[len - 1]) {
//             _glob.hasTimeOut[len - 1] = false;
//           }
//         },
//         stopSuccess(msg) {
//           $activityIndicator.stopAnimating();
//
//           msg = msg ? msg.toString(): 'Success';
//           ToastrSvc.success(msg);
//
//           var len = _glob.hasTimeOut.length;
//           if(len > 0 && _glob.hasTimeOut[len - 1]) {
//             _glob.hasTimeOut[len - 1] = false;
//           }
//         },
//         stopError(msg) {
//           $activityIndicator.stopAnimating();
//
//           if(msg) {
//             msg = msg.data ? msg.data: msg;
//             msg = msg.toString();
//           } else {
//             msg = 'Unspecified Error - Contact System Administrator';
//           }
//           ToastrSvc.error(msg);
//
//           var len = _glob.hasTimeOut.length;
//           if(len > 0 && _glob.hasTimeOut[len - 1]) {
//             _glob.hasTimeOut[len - 1] = false;
//           }
//         }
//       };
//     }
//   );
